import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexScrollable',
  setup(__props) {

const customScrollbar = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/customScrollbar.vue"))
const smallScroll = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/smallScroll.vue"))
const badgesScrollbar = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/badgesScrollbar.vue"))
const profileScrollable = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/profileScrollable.vue"))
const scrollableContent = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/scrollableContent.vue"))
const horizontalScrollbar = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/horizontalScrollbar.vue"))
const bothSide = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/bothSide.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Scrollable"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(customScrollbar)),
        _createVNode(_unref(smallScroll)),
        _createVNode(_unref(badgesScrollbar)),
        _createVNode(_unref(profileScrollable)),
        _createVNode(_unref(scrollableContent)),
        _createVNode(_unref(horizontalScrollbar)),
        _createVNode(_unref(bothSide))
      ])
    ])
  ], 64))
}
}

})